/** Customer segments (M29 Phase 2): list, editor and rules. Shell created by WP-M29-SCHEMA2: later work packages add keys inside their group (en and fil together, no dots inside key segments). */
export const segments = {
  list: {
    title: "Segments",
    subtitle: "Saved rules on what you know about a customer. Membership updates itself when their details change, and again every night.",
    crumb: "Segments",
    toContacts: "Back to contacts",
    open: "Segments",
    newSegment: "New segment",
    tableLabel: "Segments",
    loading: "Loading segments",
    nameColumn: "Segment",
    ruleColumn: "Rule",
    membersColumn: "Members",
    usedByColumn: "Used by",
    actionsColumn: "Actions",
    asOf: "as of {{time}}",
    notCounted: "Not counted yet",
    kindStandard: "Standard",
    kindSuppression: "Suppression",
    usedByContacts: "Contact filter",
    usedByReports: "Reports",
    usedByRouting: "Routing",
    usedBySuppression: "Never receives announcements",
    viewMembers: "View members",
    viewMembersFor: "View members of {{name}}",
    edit: "Edit",
    editFor: "Edit {{name}}",
    remove: "Delete",
    removeFor: "Delete {{name}}",
    emptyTitle: "No segments yet",
    emptyBody: "A segment groups customers by a rule, for example Platinum customers who are active. Use it to filter contacts, route chats and keep people out of announcements.",
    emptyCta: "Create the first segment",
    errorTitle: "Segments could not be loaded",
    errorBody: "Check your connection and try again.",
    retry: "Try again",
    offTitle: "Segments are not available for this workspace yet",
    offBody: "Live chat operations are switched off here. Ask your Sagot contact to turn them on.",
    readOnly: "You can see segments but not change them.",
    deleteTitle: "Delete {{name}}?",
    deleteBody: "The segment is removed from every filter that uses it. Customers are not affected.",
    deleteSuppressionBody: "Customers in this suppression segment will receive announcements again.",
    deleteRoutingBody: "Live-chat routing uses this segment. The rule that points at it will show as a deleted segment and stop adding points until you remove or replace it.",
    deleteConfirm: "Delete segment",
    created: "Segment {{name}} created with {{count}} members",
    updated: "Segment {{name}} saved",
    deleted: "Segment {{name}} deleted",
    failed: "That did not work. Try again.",
  },
  editor: {
    createTitle: "New segment",
    editTitle: "Edit segment",
    description: "Customers who match the rule belong to the segment. It updates when their details change.",
    nameLabel: "Name",
    namePlaceholder: "Platinum and active",
    kindLabel: "What is it for",
    kindStandard: "Standard",
    kindStandardHint: "A group to filter, route and report on.",
    kindSuppression: "Suppression",
    kindSuppressionHint: "These customers never receive announcements, whatever else targets them.",
    matchLabel: "Customers who match",
    matchAll: "all of these",
    matchAny: "any of these",
    conditionsTitle: "Conditions",
    conditionLabel: "Condition {{n}}",
    fieldLabel: "Field",
    opLabel: "Is",
    valueLabel: "Value",
    attributeKeyLabel: "Attribute key",
    attributeKeyPlaceholder: "plan_name",
    addCondition: "Add condition",
    removeCondition: "Remove condition {{n}}",
    maxConditions: "A segment can have up to {{max}} conditions.",
    listHint: "Separate values with commas.",
    daysSuffix: "days",
    save: "Save segment",
    create: "Create segment",
    cancel: "Cancel",
    saving: "Saving",
    nameRequired: "Give the segment a name.",
    nameTooLong: "Use at most {{max}} characters.",
    noConditions: "Add at least one condition.",
    tooManyConditions: "A segment can have up to {{max}} conditions.",
    problemAttributeKey: "Use lower-case letters, digits and underscores, starting with a letter.",
    problemValue: "Enter a value.",
    problemNumber: "Enter a whole number, zero or more.",
    problemDays: "Enter a whole number of days from {{min}} to {{max}}.",
    problemStatus: "Choose a known account status.",
    problemList: "Enter at least one value.",
    problemTooMany: "Use at most {{max}} values.",
    problemTooLong: "Use at most {{max}} characters per value.",
    nameTaken: "A segment with that name already exists.",
    limitReached: "This workspace already has the most segments it can hold.",
    serverError: "The server did not accept the rule. Check the highlighted conditions.",
    discardTitle: "Discard your changes?",
    discardBody: "The segment has not been saved.",
    discardConfirm: "Discard",
    keepEditing: "Keep editing",
  },
  rules: {
    field: {
      tier: "Tier",
      account_status: "Account status",
      language: "Language",
      verified: "Verified identity",
      last_active: "Last seen",
      conversations: "Chats",
      tags: "Contact tags",
      attribute: "Custom attribute",
    },
    op: {
      eq: "is",
      neq: "is not",
      in: "is one of",
      not_in: "is none of",
      is_set: "is set",
      is_not_set: "is not set",
      contains: "contains",
      gt: "is more than",
      gte: "is at least",
      lt: "is less than",
      lte: "is at most",
      has_any: "has any of",
      has_all: "has all of",
      has_none: "has none of",
      within_days: "within the last",
      older_than_days: "more than this long ago:",
    },
    status: {
      active: "Active",
      restricted: "Restricted",
      suspended: "Suspended",
      self_excluded: "Self-excluded",
      closed: "Closed",
      kyc_pending: "Verification pending",
    },
    yes: "Yes",
    no: "No",
    joinAll: "and",
    joinAny: "or",
    days_one: "{{count}} day",
    days_other: "{{count}} days",
    summary: "{{field}} {{op}} {{value}}",
    summaryNoValue: "{{field}} {{op}}",
    attributeField: "Attribute {{key}}",
    none: "No conditions",
  },
  members: {
    title: "Members of {{name}}",
    description: "{{count}} customers as of {{time}}.",
    nameColumn: "Customer",
    tierColumn: "Tier",
    statusColumn: "Status",
    lastSeenColumn: "Last seen",
    unnamed: "Unnamed customer",
    never: "Never",
    openContact: "Open contact {{name}}",
    loading: "Loading members",
    emptyTitle: "Nobody matches yet",
    emptyBody: "No customer fits this rule at the moment. The count refreshes when a customer's details change and every night.",
    errorTitle: "Members could not be loaded",
    errorBody: "Try again in a moment.",
    loadMore: "Load more",
    showing: "Showing {{shown}} of {{total}}",
    close: "Close",
    privacy: "References, e-mail addresses and phone numbers are not shown here.",
  },
  filter: {
    label: "Segment",
    all: "All customers",
    group: "Segment filter",
    count_one: "{{count}} customer in this segment, as of {{time}}. It updates automatically.",
    count_other: "{{count}} customers in this segment, as of {{time}}. It updates automatically.",
    uncounted: "This segment has not been counted yet.",
    suppression: "Suppression segment: these customers never receive announcements.",
    manage: "Manage segments",
    unknown: "Unknown segment",
    clear: "Clear segment filter",
    inContacts: "{{shown}} of {{total}} members have a contact record.",
  },
} as const;
